import { BookingStatus } from '../../gql/graphql';

export const shouldShowHazardousGoodsApproval = (
  bookingStatus: BookingStatus | null,
  hazardousGoodsApproved: boolean,
) => bookingStatus !== BookingStatus.Cancelled || hazardousGoodsApproved;
